"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-use-before-define */
exports.default = (function () {
    var eventContext = {};
    return {
        getEventContext: getEventContext,
        setEventContext: setEventContext,
    };
    function setEventContext(newEventContext) {
        Object.assign(eventContext, newEventContext || {});
    }
    function getEventContext() {
        return eventContext;
    }
});
//# sourceMappingURL=EventContext.js.map